import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { ArtistTypeEnum } from '@/generated/api';
import env from '@env';

@Component({
    components: AllComponents(),
})
export default class Complete extends Mixins(CommonView) {

    public slug: string = "";

    public planId: string = '';

    public facebookUrl: string = "";

    public twitterUrl: string = "";

    public lineUrl: string = "";

    public async created() {
        if (await this.isLoginRedirect(true)) return;

        this.slug = this.$route.params.slug;
        this.planId = this.$route.params.planId;
        let response = await SBAPI.PlanController.getPlanUsingGET(Number(this.planId))
        if (response.status != 200) {
            return;
        }
        this.plan = response.data;
        let responseArtist = await SBAPI.ArtistController.getArtistUsingGET(this.slug)
        if (responseArtist.status != 200) {
            return;
        }
        this.plan.artist = responseArtist.data;
        this.facebookUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(env.FRONT_ORIGIN + '/lineup/' + this.slug);
        this.twitterUrl = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(this.plan.artist.name + 'のプランを選択しました♪サプライズボックスはあなたの気持ちをカタチとして定期的にお届けします♪\n' + env.FRONT_ORIGIN + '/lineup/' + this.slug + '\n' + '#サプライズボックス' + '\n#' + this.plan.artist.name);
        this.lineUrl = 'http://line.me/R/msg/text/?' + encodeURIComponent(this.plan.artist.name + 'のプランを選択しました♪サプライズボックスはあなたの気持ちをカタチとして定期的にお届けします♪\n' + env.FRONT_ORIGIN + '/lineup/' + this.slug + '\n' + '#サプライズボックス' + '\n#' + this.plan.artist.name);
    }

    public plan: SBAPI.Plan = SBAPI.plan();
};